import * as React from 'react';

import { singleton } from 'logic/singleton';
import type { DataLakeInfo, DataLakeFieldsFetchQuery } from 'data-lake/preview/Types';

export type SelectedDataLakesContextValue = {
  selectDataLake?: React.Dispatch<React.SetStateAction<string>>;
  selectedDataLake: DataLakeInfo;
  dataLakeFieldsFetchQuery?: DataLakeFieldsFetchQuery;
  setDataLakeFieldsFetchQuery?: React.Dispatch<React.SetStateAction<DataLakeFieldsFetchQuery>>;
};

const SelectedDataLakesContext = React.createContext<SelectedDataLakesContextValue>(undefined);
export default singleton('contexts.SelectedDataLakesContext', () => SelectedDataLakesContext);
